<template>
  <div>
    <select 
      clearable
      :multiple="multiple"
      v-model="value"
      @change="selectChange">
      <option value="" disabled>Choose</option>
      <option 
        v-for="(item, index) in data" 
        :key="item.value + index" 
        :value="item.value"
        :disabled="disabled === item.value"
        >
        {{ item.text }}
      </option>
    </select>
  </div>
</template>

<script>
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class AdminSelect extends Vue {
  @Prop() data;
  @Prop() initial;
  @Prop() multiple;
  @Prop() disabled;

  value = null;

  selectChange() {
    this.$emit('input', this.value);
  }

  created() {
    this.value = this.initial;
  }
}
</script>
